/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OfferInStatus
 */
export interface OfferInStatus {
    /**
     * 
     * @type {string}
     * @memberof OfferInStatus
     */
    statusCode: string;
}

export function OfferInStatusFromJSON(json: any): OfferInStatus {
    return OfferInStatusFromJSONTyped(json, false);
}

export function OfferInStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferInStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'statusCode': json['statusCode'],
    };
}

export function OfferInStatusToJSON(value?: OfferInStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'statusCode': value.statusCode,
    };
}


